import { useState, useEffect } from "react";

export default function useCustomerCharges(load) {
  const [customerLinehaul, setCustomerLinehaul] = useState(0);
  const [customerFuel, setCustomerFuel] = useState([]);
  const [customerAccessorials, setCustomerAccessorials] = useState([]);

  const customerFuelCodes = ["FS", "FSD", "FSF", "FSP", "FUE", "FUEL"];

  useEffect(() => {
    if (load.id) {
      setCustomerLinehaul(load.customerLinehaul ?? 0);
      setCustomerFuel(load.otherCharges.filter(charge => customerFuelCodes.includes(charge.chargeId)));
      setCustomerAccessorials(load.otherCharges.filter(charge => !customerFuelCodes.includes(charge.chargeId)));
    }
  }, [load]);

  return { customerLinehaul, customerFuel, customerAccessorials };
}